import { render } from "./QuestionBank.vue?vue&type=template&id=15ce0b49&scoped=true"
import script from "./QuestionBank.vue?vue&type=script&lang=js"
export * from "./QuestionBank.vue?vue&type=script&lang=js"

import "./QuestionBank.vue?vue&type=style&index=0&id=15ce0b49&lang=scss&scoped=true"
import "./QuestionBank.vue?vue&type=style&index=1&id=15ce0b49&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ce0b49"]])

export default __exports__